<script lang="ts">
  import GlanceIcon from '$lib/assets/icons/GlanceIcon.svelte';
  import Hamburger from '$lib/assets/icons/Hamburger.svelte';
  import MysitesIcon from '$lib/assets/icons/MysitesIcon.svelte';
  import CategoryNavbar from '$lib/components/CategoryNavbar.svelte';
  import { CATEGORY_NAVBAR } from '$lib/constants/navbar';
  import { sendAnalyticsEvent } from '$lib/services/analytics';
  import { EventNames } from '$lib/types/analytics';
  import type { Category } from '$lib/types/category';
  import { SiteProvider } from '$lib/types/siteProvider';
  import { CookieDismiss, dismissCookieBanner } from '$lib/utils/cookie';

  export let showSideDrawer = false;
  export let source: string;

  const toggleSideBar = () => {
    sendAnalyticsEvent(EventNames.MENU_CLICK);
    showSideDrawer = !showSideDrawer;
    dismissCookieBanner(CookieDismiss.MENU);
  };

  const sortByRank = (a: Category, b: Category) => a.rank - b.rank;
  const isEnabled = (category: Category) => category.enabled;
  const categories = CATEGORY_NAVBAR.sort(sortByRank).filter(isEnabled);
</script>

<header class="header">
  <a href="/" class="link" aria-label="Home Page">
    {#if source === SiteProvider.TRACFONE}
      <MysitesIcon />
    {:else}
      <GlanceIcon />
    {/if}
  </a>
  <CategoryNavbar {categories} />

  <button class="hamburger-btn" on:click={toggleSideBar} aria-label="Menu">
    <Hamburger />
  </button>
</header>

<style lang="scss">
  // let not use fixed here, causing issues in layout
  .header {
    position: sticky;
    top: 0;
    height: var(--height-header);
    background-color: var(--color-card-background);
    padding: 0 16px;
    display: grid;
    grid-template-columns: 2fr 4fr 0.5fr;
    justify-content: center;
    align-items: center;
    z-index: var(--z-index-header);
    width: 100%;
  }

  .link {
    text-decoration: none;
    line-height: 0;
  }

  .hamburger-btn {
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
  }
</style>
